import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {
  transform(array: any[], key: string): any[] {
    if (!array) return [];

    // Agrupa por el campo indicado (producto o ubicación)
    const grouped = array.reduce((result, item) => {
      const groupKey = item[key] || 'Sin valor';
      if (!result[groupKey]) result[groupKey] = [];
      result[groupKey].push(item);
      return result;
    }, {});

    // Convierte a arreglo y calcula totales por grupo
    return Object.keys(grouped).map(group => {
      const items = grouped[group];

      const totals = {
        volumenInicial: items.reduce((a, b) => a + (b.volumenInicial || 0), 0),
        volumenRecepcionado: items.reduce((a, b) => a + (b.volumenRecepcionado || 0), 0),
        volumenEntregado: items.reduce((a, b) => a + (b.volumenEntregado || 0), 0),
        existencias: items.reduce((a, b) => a + (b.existencias || 0), 0),
      };

      return { key: group, items, totals };
    });
  }
}
